import InfoCard from '../../components/kiaPVFiveCard/InfoCard';
import Snippet from '../../components/Snippet';

const KiaPVFiveCard = () => {
  return (
    <main>
      <InfoCard />
      <Snippet page="kia-pv-five-card" />
    </main>
  );
};
export default KiaPVFiveCard;
